import { withAppCrashIfException } from 'epic';
import { pollTradesBlottersCreditCheckEpic } from 'epic/blotters/tradesBlotter/credittCheckEpic';
import {
  loadTradesBlottersFiltersEpic,
  loadTradesBlottersGlobalFiltersEpic,
  persistTradesBlottersFiltersEpic,
  persistTradesBlottersGlobalFiltersEpic,
} from 'epic/blotters/tradesBlotter/fitersEpic';
import {
  persistPreferenceStateEpic,
  tradesBlottersFilterEnabledEpic,
  tradesBlottersLoadPreferenceStateEpic,
  tradesBlottersPersistPreferenceStateEpic,
} from 'epic/blotters/tradesBlotter/preferenceState/preferenceStateEpic';
import {
  fetchDlpProductTradesBlotterEpic,
  fetchTradesBlotterPlatformsEpic,
  fetchTradesBlottersColumnDefinitionEpic,
  fetchTradesBlottersItemsEpic,
  fetchTradesBlottersTypeEpic,
  pollTradesBlottersItemsEpic,
  waitUntilBlotterLoadedToSetDefaultFilter,
} from 'epic/blotters/tradesBlotter/tradesBlottersEpic';
import { combineEpics } from 'redux-observable';

import { resetBlotterPanelEpics } from './blotterPanel/tradeBlotterPanelEpics';

export const tradesBlotterEpics = () =>
  withAppCrashIfException(
    'tradeBlotter',
    combineEpics(
      resetBlotterPanelEpics(), // OK
      ...tradesBlottersFilterEnabledEpic(),
      persistPreferenceStateEpic(),
      tradesBlottersLoadPreferenceStateEpic(),
      tradesBlottersPersistPreferenceStateEpic(),
      fetchTradesBlottersTypeEpic(),
      fetchDlpProductTradesBlotterEpic(),
      ...fetchTradesBlottersColumnDefinitionEpic(),
      ...fetchTradesBlottersItemsEpic(),
      ...persistTradesBlottersFiltersEpic(),
      ...loadTradesBlottersFiltersEpic(),
      persistTradesBlottersGlobalFiltersEpic(),
      loadTradesBlottersGlobalFiltersEpic(),
      pollTradesBlottersItemsEpic(),
      pollTradesBlottersCreditCheckEpic(),
      waitUntilBlotterLoadedToSetDefaultFilter(),
      fetchTradesBlotterPlatformsEpic(),
    ),
  );
